const getFieldName = (name, customId = null) => {
	return customId ? `${customId}_${name}` : name
}

export default getFieldName
